import { Entity } from '../../types';

export enum Requiredness {
  DISABLED = 'disabled',
  OPTIONAL = 'optional',
  REQUIRED = 'required',
}

export enum FieldDiscriminator {
  TEXT_FIELD = 'textfield',
  SINGLE_CHOICE_FIELD = 'singlechoicefield',
}

export enum AnswerDiscriminator {
  ANSWER = 'answer',
  CHOICE_FIELD_ANSWER = 'choicefieldanswer',
}

export enum AnswerStatus {
  NORMAL = 'normal',
}

export interface Form extends Entity {
  title: string;
  description: string;
  isDividedIntoChapters: boolean;
}

export interface ChoiceFieldOption extends Entity {
  label: string;
  sortOrder: number;
}

export interface AbstractField extends Entity {
  number: number;
  title: string;
  requiredness: Requiredness;
  infoText: string;
  readOnly: boolean;
  enabledByOptions: ChoiceFieldOption[];
  discr: FieldDiscriminator;
}

export interface ChoiceField extends AbstractField {
  options: ChoiceFieldOption[];
}

export interface TextField extends AbstractField {
  discr: FieldDiscriminator.TEXT_FIELD;
}

export interface SingleChoiceField extends ChoiceField {
  discr: FieldDiscriminator.SINGLE_CHOICE_FIELD;
}

export type Field = TextField | SingleChoiceField;

export interface AbstractAnswer extends Entity {
  discr: AnswerDiscriminator;
  value: string;
  status: AnswerStatus;
}

export interface Answer extends AbstractAnswer {
  discr: AnswerDiscriminator.ANSWER;
}

export interface ChoiceFieldAnswer extends AbstractAnswer {
  discr: AnswerDiscriminator.CHOICE_FIELD_ANSWER;
  chosenOptions: ChoiceFieldOption[];
}

export interface FilledOutField {
  field: Field;
  answer?: Answer | ChoiceFieldAnswer;
}

export interface File extends Entity {
  name: string;
  type: string;
  hash: string;
  size: number;
}

// forms don't have chapters in this application, but we keep the interface for future reference
export interface FormEntry extends Entity {
  filledOutChapters?: never;
  filledOutFields?: FilledOutField[];
  pdf?: File;
}

export type DynamicFormState = 'open' | 'reviewing' | 'final';

export interface FieldProps {
  state: DynamicFormState;
  filledOutField: FilledOutField;
  hasServerError: boolean;
}

export type AnswerValue = string | number[];

export interface AnswerValues {
  [key: string]: AnswerValue;
}
